export enum RepliersListingLotMeasurementUnits {
  'Feet' = 'Feet',
  'Foot' = 'Foot',
  'Ft' = 'Ft',
  'Fe' = 'Fe',
  'F' = 'F',
  'Sq_Ft' = 'Sq Ft',
  'Sq_Ft_Divisible' = 'Sq. Ft. Divisible',
  'Square_Feet' = 'Square Feet',
  'Acres' = 'Acres',
  'Acres1' = 'Acres1',
  'Acres2' = 'Acres2',
  'Hectares' = 'Hectares',
  'Metres' = 'Metres',
  'Me' = 'Me',
  'Square_Meters' = 'Square Meters',
}
